module.exports = __webpack_public_path__ + "static/media/twitter-color.12493550.svg";